import { render, staticRenderFns } from "./overdueSupplyReviewDetail.vue?vue&type=template&id=556a9d4b&scoped=true"
import script from "./overdueSupplyReviewDetail.vue?vue&type=script&lang=js"
export * from "./overdueSupplyReviewDetail.vue?vue&type=script&lang=js"
import style0 from "./overdueSupplyReviewDetail.vue?vue&type=style&index=0&id=556a9d4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a9d4b",
  null
  
)

export default component.exports